import { Component } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Inject, OnInit } from '@angular/core';

@Component({
  selector: 'app-population-details-popup',
  templateUrl: './population-details-popup.component.html',
  styleUrl: './population-details-popup.component.scss',
  standalone: false,
})
export class PopulationDetailsPopupComponent implements OnInit {
  public residency: string[] = [];

  public service: string = '';

  constructor(
    public dialogRef: MatDialogRef<PopulationDetailsPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.residency =
      (this.data?.selectedPopulation.residency?.length ?? 0) === 1
        ? [...this.data?.selectedPopulation.residency]
        : ['Titulaire', 'Vacataire'];

    const service = this.data.selectedPopulation.services ?? 'all';
    this.service = service === 'main' ? 'Service principal' : service === 'all' ? 'Tous les services' : service;
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
